import React from "react";
import { Box } from "@mui/material";

const BentoItem = ({ children, colSpan, colStart, sx = {}, masonry = true, ...rest }) => {
  // Only handle colSpan — rowSpan is now handled dynamically by BentoBoxGrid in grid mode
  const getResponsiveGridValue = (value, start) => {
    if (typeof value === "object" && value !== null) {
      const result = {};
      Object.entries(value).forEach(([breakpoint, v]) => {
        result[breakpoint] = start ? `${start} / span ${v}` : `span ${v}`;
      });
      return result;
    }
    return start ? `${start} / span ${value}` : `span ${value}`;
  };

  if (masonry) {
    // In Masonry mode, just render the content block
    return (
      <Box sx={{ width: '100%', mb: 0, ...sx }} {...rest}>
        <Box className="bento-item-inner" sx={{ width: "100%" }}>
          {children}
        </Box>
      </Box>
    );
  }

  const gridStyles = {
    ...(colSpan !== undefined && {
      gridColumn: getResponsiveGridValue(colSpan, colStart),
    }),
    ...sx,
  };
  return (
    <Box sx={{ ...gridStyles, minWidth: 0 }} {...rest}>
      <Box className="bento-item-inner" sx={{ width: "100%" }}>
        {children}
      </Box>
    </Box>
  );
};

export default BentoItem;
